import { render, staticRenderFns } from "./sales-quotes-carousel-sheet.vue?vue&type=template&id=713878b6&"
import script from "./sales-quotes-carousel-sheet.component.ts?vue&type=script&lang=ts&"
export * from "./sales-quotes-carousel-sheet.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports